<template>
  <div class="agent-product-cards" v-if="cards.length">
    <component
      :is="cardAction(card).kind === 'web' ? 'a' : (cardAction(card).kind === 'mini_program' ? 'button' : 'div')"
      v-for="card in cards"
      :key="card.id"
      class="product-card"
      :href="cardAction(card).href || null"
      :target="cardAction(card).kind === 'web' ? '_blank' : null"
      :rel="cardAction(card).kind === 'web' ? 'noopener noreferrer' : null"
      :type="cardAction(card).kind === 'mini_program' ? 'button' : null"
      @click="openCard(card)"
    >
      <img v-if="card.imageUrl" :src="card.imageUrl" :alt="card.name" class="product-image">
      <div v-else class="product-image product-image--empty">
        <i class="el-icon-picture-outline"></i>
      </div>
      <div class="product-info">
        <div class="product-name">{{ card.name }}</div>
        <div v-if="card.subtitle" class="product-subtitle">{{ card.subtitle }}</div>
        <div v-if="card.price !== ''" class="product-price"><span>¥</span>{{ card.price }}</div>
      </div>
    </component>
    <el-dialog title="微信小程序商品" :visible.sync="miniProgramVisible" width="520px" append-to-body>
      <p>该商品在微信小程序中打开。请在微信内使用以下小程序信息：</p>
      <p v-if="selectedMiniProgram"><strong>小程序 AppID：</strong>{{ selectedMiniProgram.appId }}</p>
      <el-input v-if="selectedMiniProgram" :value="selectedMiniProgram.path" readonly aria-label="小程序商品路径" />
      <span slot="footer">
        <el-button @click="miniProgramVisible = false">关闭</el-button>
        <el-button type="primary" @click="copyMiniProgramPath">复制商品路径</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { productCardAction } from '@/utils/agent-chat-event-adapter.mjs'

export default {
  name: 'AgentProductCards',
  props: {
    structuredData: {
      type: Object,
      default: null
    }
  },
  data() {
    return { miniProgramVisible: false, selectedMiniProgram: null }
  },
  computed: {
    cards() {
      return this.structuredData && this.structuredData.kind === 'product_cards' && Array.isArray(this.structuredData.cards)
        ? this.structuredData.cards
        : []
    }
  },
  methods: {
    cardAction(card) {
      return productCardAction(card)
    },
    openCard(card) {
      const action = productCardAction(card)
      if (action.kind !== 'mini_program') return
      this.selectedMiniProgram = action
      this.miniProgramVisible = true
    },
    async copyMiniProgramPath() {
      if (!this.selectedMiniProgram) return
      try {
        await navigator.clipboard.writeText(this.selectedMiniProgram.path)
        this.$message.success('商品路径已复制')
      } catch (_) {
        this.$message.warning('复制失败，请选中路径手动复制')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.agent-product-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  margin-top: 10px;
}

.product-card {
  display: flex;
  min-width: 0;
  padding: 10px;
  color: inherit;
  text-decoration: none;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  text-align: left;
  font: inherit;
}

button.product-card {
  width: 100%;
  cursor: pointer;
}

button.product-card:hover,
a.product-card:hover {
  border-color: #409eff;
}

.product-image {
  width: 58px;
  height: 58px;
  flex: 0 0 58px;
  object-fit: cover;
  border-radius: 6px;
  background: #f5f7fa;
}

.product-image--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 22px;
}

.product-info {
  min-width: 0;
  margin-left: 10px;
}

.product-name {
  overflow: hidden;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-subtitle {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.product-price {
  margin-top: 6px;
  color: #f56c6c;
  font-weight: 600;
}

.product-price span {
  margin-right: 2px;
  font-size: 12px;
}
</style>
